import glamorous from 'glamorous';
import React from 'react';
import { ColumnsUtils, createPureComponent } from 'module/Common';
import { ContentRichTextThreeCols } from 'module/Model/Content';
import { LocalizedContent, RichText as RichTextRender, Sizes } from 'module/View/Common';

type Props = {
  item: ContentRichTextThreeCols;
  itemIndex: number;
  availableWidth: number;
  cols: ColumnsUtils.ColumnsResult;
  isCover: boolean;
};

const Wrapper = glamorous.div<{ colCount: number }>(p => ({
  display: 'flex',
  verticalAlign: 'top',
  flexDirection: p.colCount === 1 ? 'column' : 'row',
  pointerEvents: 'none',
}));

type ColumnProps = {
  rightSpace?: number;
  leftSpace?: number;
  top?: number;
  width: number;
};

const Column = glamorous.div<ColumnProps>(({ rightSpace = 0, leftSpace = 0, width, top = 0 }) => ({
  marginRight: rightSpace,
  marginLeft: leftSpace,
  width,
  marginTop: top,
  pointerEvents: 'all',
}));

export const RichTextThreeCols = createPureComponent<Props>(
  'RichTextThreeCols',
  ({ item, itemIndex, availableWidth, cols, isCover }) => {
    const elemWidth =
      !isCover && ContentRichTextThreeCols.isFullWidth(item)
        ? availableWidth
        : cols.size(Sizes.allColumnsMinusOne(cols.nbOfColumns));

    const colCount = elemWidth < 700 ? 1 : 3;
    const topColSpace = colCount === 1 ? 10 : 0;

    const localCols = ColumnsUtils.getColumns({
      availableWidth: elemWidth,
      nbOfColumns: colCount,
      spaceBetween: Sizes.smallGutter,
      spaceAround: [0, 0],
    });
    return (
      <Wrapper colCount={colCount}>
        <Column
          rightSpace={colCount === 1 ? 0 : cols.spaceBetween}
          leftSpace={localCols.position(0)}
          width={localCols.size(1)}
        >
          <LocalizedContent content={ContentRichTextThreeCols.getLeftContent(item)}>
            {content => <RichTextRender content={content} />}
          </LocalizedContent>
        </Column>
        <Column
          rightSpace={colCount === 1 ? 0 : cols.spaceBetween}
          leftSpace={colCount === 1 ? localCols.position(0) : 0}
          width={localCols.size(1)}
          top={topColSpace}
        >
          <LocalizedContent content={ContentRichTextThreeCols.getCenterContent(item)}>
            {content => <RichTextRender content={content} />}
          </LocalizedContent>
        </Column>
        <Column width={localCols.size(1)} leftSpace={colCount === 1 ? localCols.position(0) : 0} top={topColSpace}>
          <LocalizedContent content={ContentRichTextThreeCols.getRightContent(item)}>
            {content => <RichTextRender content={content} />}
          </LocalizedContent>
        </Column>
      </Wrapper>
    );
  }
);



// WEBPACK FOOTER //
// ./src/module/View/Content/component/ContentItems/items/RichTextThreeCols.tsx